const countries = [
  {
    label: "Afghanistan",
  },
  {
    label: "Albania",
  },
  {
    label: "Algeria",
  },
  {
    label: "Andorra",
  },
  {
    label: "Angola",
  },
  {
    label: "Antigua and Barbuda",
  },
  {
    label: "Argentina",
  },
  {
    label: "Armenia",
  },
  {
    label: "Aruba",
  },
  {
    label: "Australia",
  },
  {
    label: "Austria",
  },
  {
    label: "Azerbaijan",
  },
  {
    label: "Bahamas",
  },
  {
    label: "Bahrain",
  },
  {
    label: "Bangladesh",
  },
  {
    label: "Barbados",
  },
  {
    label: "Belarus",
  },
  {
    label: "Belgium",
  },
  {
    label: "Belize",
  },
  {
    label: "Bolivia",
  },
  {
    label: "Bosnia and Herzegovina",
  },
  {
    label: "Botswana",
  },
  {
    label: "Brazil",
  },
  {
    label: "Brunei",
  },
  {
    label: "Bulgaria",
  },
  {
    label: "Cambodia",
  },
  {
    label: "Cameroon",
  },
  {
    label: "Canada",
  },
  {
    label: "Cayman Islands",
  },
  {
    label: "Chile",
  },
  {
    label: "China",
  },
  {
    label: "Colombia",
  },
  {
    label: "Congo",
  },
  {
    label: "Costa Rica",
  },
  {
    label: "Croatia",
  },
  {
    label: "Cuba",
  },
  {
    label: "Cyprus",
  },
  {
    label: "Czech Republic",
  },
  {
    label: "Denmark",
  },
  {
    label: "Dominican Republic",
  },
  {
    label: "Ecuador",
  },
  {
    label: "Egypt",
  },
  {
    label: "El Salvador",
  },
  {
    label: "Estonia",
  },
  {
    label: "Faroe Islands",
  },
  {
    label: "Finland",
  },
  {
    label: "France",
  },
  {
    label: "French Polynesia",
  },
  {
    label: "Gabon",
  },
  {
    label: "Georgia",
  },
  {
    label: "Germany",
  },
  {
    label: "Ghana",
  },
  {
    label: "Greece",
  },
  {
    label: "Greenland",
  },
  {
    label: "Guadeloupe",
  },
  {
    label: "Guam",
  },
  {
    label: "Guatemala",
  },
  {
    label: "Guinea",
  },
  {
    label: "Haiti",
  },
  {
    label: "Hashemite Kingdom of Jordan",
  },
  {
    label: "Honduras",
  },
  {
    label: "Hong Kong",
  },
  {
    label: "Hungary",
  },
  {
    label: "Iceland",
  },
  {
    label: "India",
  },
  {
    label: "Indonesia",
  },
  {
    label: "Iran",
  },
  {
    label: "Iraq",
  },
  {
    label: "Ireland",
  },
  {
    label: "Isle of Man",
  },
  {
    label: "Israel",
  },
  {
    label: "Italy",
  },
  {
    label: "Jamaica",
  },
  {
    label: "Japan",
  },
  {
    label: "Kazakhstan",
  },
  {
    label: "Kenya",
  },
  {
    label: "Kosovo",
  },
  {
    label: "Kuwait",
  },
  {
    label: "Latvia",
  },
  {
    label: "Lebanon",
  },
  {
    label: "Libya",
  },
  {
    label: "Liechtenstein",
  },
  {
    label: "Luxembourg",
  },
  {
    label: "Macedonia",
  },
  {
    label: "Madagascar",
  },
  {
    label: "Malaysia",
  },
  {
    label: "Malta",
  },
  {
    label: "Martinique",
  },
  {
    label: "Mauritius",
  },
  {
    label: "Mayotte",
  },
  {
    label: "Mexico",
  },
  {
    label: "Mongolia",
  },
  {
    label: "Montenegro",
  },
  {
    label: "Morocco",
  },
  {
    label: "Mozambique",
  },
  {
    label: "Myanmar [Burma]",
  },
  {
    label: "Namibia",
  },
  {
    label: "Nepal",
  },
  {
    label: "Netherlands",
  },
  {
    label: "New Caledonia",
  },
  {
    label: "New Zealand",
  },
  {
    label: "Nicaragua",
  },
  {
    label: "Nigeria",
  },
  {
    label: "Norway",
  },
  {
    label: "Oman",
  },
  {
    label: "Pakistan",
  },
  {
    label: "Palestine",
  },
  {
    label: "Panama",
  },
  {
    label: "Papua New Guinea",
  },
  {
    label: "Paraguay",
  },
  {
    label: "Peru",
  },
  {
    label: "Philippines",
  },
  {
    label: "Poland",
  },
  {
    label: "Portugal",
  },
  {
    label: "Puerto Rico",
  },
  {
    label: "Republic of Korea",
  },
  {
    label: "Republic of Lithuania",
  },
  {
    label: "Republic of Moldova",
  },
  {
    label: "Romania",
  },
  {
    label: "Russia",
  },
  {
    label: "Saint Lucia",
  },
  {
    label: "San Marino",
  },
  {
    label: "Saudi Arabia",
  },
  {
    label: "Senegal",
  },
  {
    label: "Serbia",
  },
  {
    label: "Singapore",
  },
  {
    label: "Slovakia",
  },
  {
    label: "Slovenia",
  },
  {
    label: "South Africa",
  },
  {
    label: "Spain",
  },
  {
    label: "Sri Lanka",
  },
  {
    label: "Sudan",
  },
  {
    label: "Suriname",
  },
  {
    label: "Swaziland",
  },
  {
    label: "Sweden",
  },
  {
    label: "Switzerland",
  },
  {
    label: "Taiwan",
  },
  {
    label: "Tanzania",
  },
  {
    label: "Thailand",
  },
  {
    label: "Trinidad and Tobago",
  },
  {
    label: "Tunisia",
  },
  {
    label: "Turkey",
  },
  {
    label: "U.S. Virgin Islands",
  },
  {
    label: "Ukraine",
  },
  {
    label: "United Arab Emirates",
  },
  {
    label: "United Kingdom",
  },
  {
    label: "United States",
  },
  {
    label: "Uruguay",
  },
  {
    label: "Venezuela",
  },
  {
    label: "Vietnam",
  },
  {
    label: "Zambia",
  },
  {
    label: "Zimbabwe",
  },
];

module.exports = { countries };
